import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

declare var Stripe;

@Injectable()
export class StripeServiceProvider {

  public tuid: any = localStorage.getItem('tuid');
  public customerId: any = null;
  public currentTeamId: any = null;

  constructor(public http: HttpClient) {

  }

  setCustomerDetails() {
    // @todo Investigate if there's a better solution than calling this method at the beginning of each provider method
    // For some reason fetching the localStorage values in the constructor or at declaration localstorage can return null
    // values which means all methods don't work. This is only an issue when deployed to device, in the browser it doesnt
    // appear to be an issue.

    return new Promise(resolve => {

      this.tuid = localStorage.getItem('tuid');
      this.customerId = localStorage.getItem('stripeCustomerId');
      this.currentTeamId = localStorage.getItem('currentTeamId');
      // If we attempt to perform a method within the provider and a customerId is not found we will attempt to fetch or create a customer id
      if (this.tuid && !this.customerId) {
        return this.registerWithStripe().then(() => {
          return resolve();
        })
      } else {
        return resolve();
      }

    });
  }

  setupIntent() {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        this.http.get(`/stripe/setup-intent/create`).subscribe((intent: any) => {
          resolve(intent)
        }, error => {
          reject(error);
        });

      });

    })
  }

  cancelPaymentIntent(paymentIntentId) {
    return new Promise((resolve, reject) => {

      this.setCustomerDetails().then(() => {
        this.http.post(`/stripe/payment-intent/cancel`, {
          'intent': paymentIntentId
        }).subscribe((intent: any) => {
          resolve(intent)
        }, error => {
          reject(error);
        });
      });

    })
  }

  registerWithStripe() {
    return new Promise(resolve => {
      // console.log('Attempt to register with stripe');
      this.tuid = localStorage.getItem('tuid');
      this.customerId = localStorage.getItem('stripeCustomerId');
      // console.log('TUID:');
      // console.log(this.tuid);
      // console.log('CustomerID:');
      // console.log(this.customerId);
      if (this.tuid && !this.customerId) {
        this.http.post('/stripe/customers/create', {
          id: this.tuid
        }).subscribe((data: any) => {
          if (data && data.message == 'User not found') {
            return resolve(data);
          } else {
            this.customerId = data;
            localStorage.setItem('stripeCustomerId', data);
          }
          return resolve(data);
        });
      }
    });
  }

  getCustomer() {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        this.http.get(`/stripe/customers/${this.customerId}`).subscribe((customer: any) => {
          resolve(customer)
        }, error => {
          reject(error);
        });
      });
    });
  }

  attachPaymentMethod(intent) {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        console.log("customer Id", this.customerId);

        this.http.post(`/stripe/setup-intent/attach/${this.customerId}`, {
          intent: intent
        }).subscribe((paymentMethod: any) => {
          resolve(paymentMethod)
        }, error => {
          reject(error);
        });
      });
    });
  }

  detachPaymentMethod(paymentMethodId: string) {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        this.http.delete(`/stripe/payment-methods/${paymentMethodId}/detach`).subscribe((customer: any) => {
          resolve(customer)
        }, error => {
          reject(error);
        });
      });
    });
  }

  getPaymentMethods() {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        this.http.get(`/stripe/payment-methods/${this.customerId}`).subscribe((response: any) => {
          resolve(response);
        }, error => {
          reject(error);
        });
      });
    });
  }

  changePaymentMethod(paymentMethodId: string) {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        this.http.post(`/stripe/payment-methods/change-default-method`, {
          customerId: this.customerId,
          paymentMethodId: paymentMethodId
        }).subscribe((customer: any) => {
          resolve(customer)
        }, error => {
          reject(error);
        });
      });
    });
  }

  getPayments() {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        this.http.get(`/stripe/charges/${this.customerId}`).subscribe((payments: any) => {
          resolve(payments)
        }, error => {
          reject(error);
        });
      });
    });
  }

  createPaymentIntent(amount, customer, teamId) {
    return new Promise((resolve, reject) => {
      this.setCustomerDetails().then(() => {
        this.http.post('/stripe/payment-intent/create', {
          amount: amount * 100,
          customer: customer,
          teamId: teamId
        }).subscribe((intent: any) => {
          if (intent.status === 'succeeded') {
            return resolve(intent)
          }

          // this.stripe.confirmCardPayment(intent.client_secret, {
          //   payment_method: intent.payment_method
          // }).then(function (result) {
          //   if (result.error) {
          //     reject(result.error);
          //   } else {
          //     if (result.paymentIntent.status === 'succeeded') {
          //       resolve(result.paymentIntent)
          //     }
          //   }
          // });
        }, error => {
          reject(error);
        });
      });
    });
  }

  validateCard(payload: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`/card-details`, payload).subscribe((intent: any) => {
        resolve(intent)
      }, error => {
        reject(error);
      });
    });
  }

  confirmCardSetup(cardDetails: any) {
    return new Promise((resolve, reject) => {
      this.http.post(`/stripe/payment-methods`, cardDetails).subscribe((intent: any) => {
        resolve(intent)
      }, error => {
        reject(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/stripe-service/stripe-service.ts